<template>
  <v-container
    fluid
    fill-height
    class="grey lighten-4"
  >
    <v-layout
      :align-center="loading || !messages.length"
      :justify-center="loading || !messages.length"
    >
      <div class="pa-2">
        <fullpage-loader
          message="טוען הודעות..."
          v-if="loading"
        ></fullpage-loader>
        <message
          v-for="message in filteredMessages"
          :key="message._id"
          :message="message"
          v-else-if="filteredMessages.length"
        />
        <span v-else-if="!messages.length">אין הודעות</span>
        <span v-else>אף הודעה לא מתאימה לסינון הנוכחי.<v-btn
            small
            @click="chatFilter = {}"
          >בטל סינון</v-btn></span>
      </div>
    </v-layout>
  </v-container>
</template>

<script>
import Message from "./Message.vue";
import FullpageLoader from "../FullpageLoader.vue";
import { throttle } from "lodash";
import { setTimeout } from "timers";

export default {
  data() {
    return {
      loading: true,
      newMessagesButton: false,
      throttledOnScroll: null
    };
  },

  computed: {
    messages() {
      // If chatId is null, we're showing multiple chats (כולם mode)
      if (!this.chatId) {
        // Get all chat messages from the store
        const allMessages = [];
        const eventIdsToShow = this.$store.getters["events/eventIdsToShow"];
        
        // Get all chat IDs for the events we want to show
        const allChats = Object.values(this.$store.state.entities.chats);
        const chatIds = allChats
          .filter(chat => eventIdsToShow.includes(chat.event))
          .map(chat => chat._id);
        
        // Get messages for all chat IDs
        chatIds.forEach(chatId => {
          const chatMessages = this.$store.getters["chats/chatMessages"](chatId);
          if (chatMessages && chatMessages.length > 0) {
            allMessages.push(...chatMessages);
          }
        });
        
        // Sort by date
        return allMessages.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
      } else {
        // Single chat mode
        return this.$store.getters["chats/chatMessages"](this.chatId);
      }
    },
    filteredMessages() {
      let messages = this.messages;

      console.log('Messages filteredMessages - chatFilter:', this.chatFilter);
      if (!this.chatFilter) return messages;

      // filter by tags
      let tags = this.chatFilter.tags;
      if (tags && Array.isArray(tags) && tags.length) {
        messages = messages.filter(item => {
          if (Array.isArray(item.tags)) {
            console.log(tags.some(r => item.tags.indexOf(r) >= 0));
            return tags.some(r => item.tags.indexOf(r) >= 0);
          }
          return false;
        });
      }

      // filter by search term
      let search = this.chatFilter.search;
      
      if (search) {
        messages = messages.filter(item => {
          return item.text ? item.text.indexOf(search) >= 0 : false;
        });
      }

      // filter by attachments
      let hasAttachments = this.chatFilter.hasAttachments;
      if (hasAttachments === true || hasAttachments === false) {
        messages = messages.filter(item => {
          console.log(item.blocks, hasAttachments);
          return (
            (item.blocks.legnth && hasAttachments) ||
            (!item.blocks.legnth && !hasAttachments)
          );
        });
      }

      // filter by Event (only in כולם mode)
      let event = this.chatFilter.event;
      console.log('Messages filteredMessages - event filter:', event);
      console.log('Messages filteredMessages - this.chatId:', this.chatId);
      console.log('Messages filteredMessages - messages before event filter:', messages.length);
      
      if (event && !this.chatId) { // Only filter by Event when showing multiple chats
        // Extract event ID from the event object
        const eventId = typeof event === 'object' && event.id ? event.id : event;
        console.log('Messages filteredMessages - filtering by event ID:', eventId);
        const beforeCount = messages.length;
        messages = messages.filter(item => {
          // Get the chat for this message
          const chat = Object.values(this.$store.state.entities.chats).find(c => c._id === item.chat);
          console.log('Messages filteredMessages - message item:', item._id, 'chat:', item.chat);
          console.log('Messages filteredMessages - found chat:', chat);
          const matches = chat && chat.event === eventId;
          console.log('Messages filteredMessages - chat.event:', chat ? chat.event : 'no chat', 'filter event ID:', eventId, 'matches:', matches);
          return matches;
        });
        console.log('Messages filteredMessages - filtered from', beforeCount, 'to', messages.length, 'messages');
      } else {
        console.log('Messages filteredMessages - skipping event filter (event:', event, 'chatId:', this.chatId, ')');
      }

      console.log('Messages filteredMessages - final messages count:', messages.length);
      return messages;
    },
    chatFilter: {
      get() {
        return this.$store.getters["chats/filter"](this.chatComponentId);
      },
      set(val) {
        this.$store.commit("chats/SET_CHAT_FILTER", {
          val,
          compId: this.chatComponentId
        });
      }
    },
    autoScroll() {
      return true;
    },
    scrollableElement() {
      return document.getElementById(this.chatComponentId);
    },
    showScrollToNewMessagesButton: {
      get() {
        return this.$store.getters["chats/showScrollToNewMessagesButton"];
      },
      set(val) {
        return this.$store.commit(
          "chats/SET_SHOW_SCROLL_TO_NEW_MESSAGES_BUTTON",
          val
        );
      }
    },
    newMessagesCount: {
      get() {
        return this.$store.getters["chats/newMessagesCount"];
      },
      set(val) {
        return this.$store.commit("chats/SET_NEW_MESSAGES_COUNT", val);
      }
    }
  },

  methods: {
        fetchMessages() {
      this.loading = true;
      
      // Clear existing messages first to prevent showing old messages
      this.$store.commit("chats/CLEAR_CHAT_MESSAGES");
      
      // Get event IDs to show from store
      const eventIdsToShow = this.$store.getters["events/eventIdsToShow"];
      console.log('Messages fetchMessages - eventIdsToShow:', eventIdsToShow);
      
      // Get all chat IDs for the events we want to show
      const chatIds = [];
      const allChats = Object.values(this.$store.state.entities.chats);
      console.log('Messages fetchMessages - all chats:', allChats);
      
      allChats.forEach(chat => {
        console.log('Messages fetchMessages - checking chat:', chat._id, 'event:', chat.event, 'includes:', eventIdsToShow.includes(chat.event));
        if (eventIdsToShow.includes(chat.event)) {
          chatIds.push(chat._id);
        }
      });
      
      console.log('Messages fetchMessages - chatIds:', chatIds);
      
      let query = {};
      if (chatIds.length === 1) {
        query.chat = chatIds[0];
      } else if (chatIds.length > 1) {
        query.chat = { $in: chatIds };
      } else {
        // No chats found - use null to get empty result
        query.chat = null;
      }
      
      console.log('Messages fetchMessages - query:', query);
      
      this.$store
        .dispatch("API_GET", {
          url: "/chat-messages",
          entityType: "chatMessage",
          schema: "chatMessageListSchema",
          params: {
            q: JSON.stringify(query),
            limit: 0
          },
          replace: true
        })
        .catch(err => {
          this.$store.dispatch("SHOW_SNACKBAR", {
            text: err.message,
            color: "error"
          });
        })
        .finally(() => {
          this.loading = false;
          this.scrollToNewset(true);
        });
    },
    isScrolledBottom() {
      let scrollBuffer = 50;
      return (
        this.scrollableElement.scrollHeight -
          (this.scrollableElement.scrollTop +
            this.scrollableElement.clientHeight) <
        scrollBuffer
      );
    },
    hideScrollToNewsetButton() {
      this.newMessagesCount = 0;
      this.showScrollToNewMessagesButton = false;
    },
    scrollToNewset(force = false) {
      let isScrolledBottom = this.isScrolledBottom(); // must be before $nextTick
      this.$nextTick(() => {
        if (force || (this.autoScroll && isScrolledBottom)) {
          this.hideScrollToNewsetButton();
          let chatContainer = this.scrollableElement;
          chatContainer.scrollTop = chatContainer.scrollHeight;
        }
      });
    },
    onScroll(e) {
      if (this.isScrolledBottom()) {
        this.hideScrollToNewsetButton();
      } else {
        this.showScrollToNewMessagesButton = true;
      }
    }
  },

  mounted() {
    this.fetchMessages();

    this.throttledOnScroll = throttle(this.onScroll, 500);
    this.scrollableElement.addEventListener("scroll", this.throttledOnScroll);

    this.$bus.$on("scroll-chat-" + this.chatComponentId, () => {
      this.scrollToNewset(true);
    });
    
    // Listen for global refetch event
    this.$bus.$on('refetch-all-data', () => {
      console.log('Messages - received global refetch event');
      this.fetchMessages();
    });
  },

  beforeDestroy() {
    this.scrollableElement.removeEventListener(
      "scroll",
      this.throttledOnScroll
    );
    
    // Clean up global event listener
    this.$bus.$off('refetch-all-data');
  },

  watch: {
    messages: function(val, oldVal) {
      console.log(val, oldVal);
      this.newMessagesCount += val.length - oldVal.length;
      if (!oldVal || oldVal.length === 0) {
        setTimeout(() => {
          this.scrollToNewset(true);
        }, 1);
      } else {
        this.scrollToNewset();
      }
    },
    chatFilter: function(val) {
      setTimeout(() => {
        this.scrollToNewset(true);
      }, 1);
    },
    // Watch for event IDs to show changes (כולם mode)
    '$store.state.events.eventIdsToShow': {
      handler(newVal, oldVal) {
        console.log('Messages watcher - eventIdsToShow changed from:', oldVal, 'to:', newVal);
        console.log('Messages watcher - newVal type:', typeof newVal, 'length:', newVal ? newVal.length : 'undefined');
        if (newVal && newVal.length > 0) {
          // Clear messages first, then fetch new data
          this.$store.commit("chats/CLEAR_CHAT_MESSAGES");
          this.fetchMessages();
        } else {
          console.log('Messages watcher - skipping fetch because eventIdsToShow is empty');
        }
      },
      deep: true
    },
    // Watch for route changes to refetch data when switching events
    '$route.params.id': {
      handler(newEventId, oldEventId) {
        console.log('Messages watcher - route changed from:', oldEventId, 'to:', newEventId);
        if (newEventId && newEventId !== oldEventId) {
          // Clear messages first, then fetch new data
          this.$store.commit("chats/CLEAR_CHAT_MESSAGES");
          this.fetchMessages();
        }
      },
      immediate: true
    },
    // Watch for chatId changes to refetch messages
    chatId: {
      handler(newChatId, oldChatId) {
        console.log('Messages watcher - chatId changed from:', oldChatId, 'to:', newChatId);
        this.fetchMessages();
      },
      immediate: true
    },
    // Watch for chat data in store to refetch messages
    '$store.state.entities.chats': {
      handler(newChats, oldChats) {
        console.log('Messages watcher - chats in store changed');
        // Only refetch if we have a chatId and chats were actually loaded
        if (this.chatId && Object.keys(newChats).length > 0) {
          this.fetchMessages();
        }
      },
      deep: true
    },
    // Watch for showAllEvents changes (כולם toggle)
    '$store.state.events.showAllEvents': {
      handler(newShowAll, oldShowAll) {
        console.log('Messages watcher - showAllEvents changed from:', oldShowAll, 'to:', newShowAll);
        // Clear messages first, then fetch new data
        this.$store.commit("chats/CLEAR_CHAT_MESSAGES");
        this.fetchMessages();
      }
    }
  },

  props: ["chatId", "chatComponentId"],

  components: {
    Message,
    FullpageLoader
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container {
  margin: 0;
  padding: 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/chat/Messages.vue